import { useEffect, useRef, useState } from "react";
import { Chart } from "lightweight-charts-react-wrapper";
import { LineStyle, ColorType, PriceScaleMode } from 'lightweight-charts';
import Series from "./Series";

/* Custom charts container, wrapper for the lightweight charts and series
Has settings listed below, change what is required.
*/
export function ChartContainer() {
    const chartRef = useRef(null);

    const [chartOptions, setChartOptions] = useState({ //https://github.com/tradingview/lightweight-charts/blob/v3.3.0/docs/customization.md
        //width: 600,
        height: 600,
        autoSize: false,
        layout: {
            background: {
                type: ColorType.Solid,
                color: '#222',
            },
            textColor: '#DDD',
            // fontSize: 12,
            // fontFamily: defaultFontFamily,
        },
        // crosshair: {
        //     vertLine: {
        //         color: '#9598A1',
        //         width: 1,
        //         style: LineStyle.LargeDashed,
        //         visible: true,
        //         labelVisible: true,
        //         labelBackgroundColor: '#131722',
        //     },
        //     horzLine: {
        //         color: '#9598A1',
        //         width: 1,
        //         style: LineStyle.LargeDashed,
        //         visible: true,
        //         labelVisible: true,
        //         labelBackgroundColor: '#131722',
        //     },
        //     mode: CrosshairMode.Magnet,
        // },
        grid: {
            vertLines: {
                color: '#444',
                style: LineStyle.Solid,
                visible: true,
            },
            horzLines: {
                color: '#444',
                style: LineStyle.Solid,
                visible: true,
            },
        },
        // overlayPriceScales: {
        // 	...priceScaleOptionsDefaults,
        // },
        // leftPriceScale: {
        //     autoScale: true,
        //     mode: PriceScaleMode.Normal,
        //     invertScale: false,
        //     alignLabels: true,
        //     borderVisible: true,
        //     borderColor: '#2B2B43',
        //     entireTextOnly: false,
        //     visible: false,
        //     ticksVisible: false,
        //     scaleMargins: {
        //         bottom: 0.1,
        //         top: 0.2,
        //     },
        //     minimumWidth: 0,
        // },
        rightPriceScale: {
            autoScale: true,
            mode: PriceScaleMode.Normal,
            invertScale: false,
            alignLabels: true,
            borderVisible: true,
            borderColor: '#71649C',
            textColor: "#FFF",
            entireTextOnly: false,
            visible: true,
            ticksVisible: true,
            scaleMargins: {
                bottom: 0.1,
                top: 0.2,
            },
            minimumWidth: 0,
        },
        timeScale: {
            rightOffset: 10,
            barSpacing: 6,
            minBarSpacing: 0.5,
            fixLeftEdge: false,
            fixRightEdge: false,
            lockVisibleTimeRangeOnResize: false,
            rightBarStaysOnScroll: false,
            borderVisible: true,
            borderColor: '#71649C',
            visible: true,
            timeVisible: true,
            secondsVisible: true,
            shiftVisibleRangeOnNewBar: true,
            allowShiftVisibleRangeOnWhitespaceReplacement: false,
            ticksVisible: true,
            uniformDistribution: false,
            minimumHeight: 0,
            allowBoldLabels: true,
        },
        // watermark: {
        //     color: 'rgba(0, 0, 0, 0)',
        //     visible: false,
        //     fontSize: 48,
        //     fontFamily: defaultFontFamily,
        //     fontStyle: '',
        //     text: '',
        //     horzAlign: 'center',
        //     vertAlign: 'center',
        // },
        // localization: {
        // 	locale: isRunningOnClientSide ? navigator.language : '',
        // 	dateFormat: 'dd MMM \'yy',
        // },
        // handleScroll: {
        // 	mouseWheel: true,
        // 	pressedMouseMove: true,
        // 	horzTouchDrag: true,
        // 	vertTouchDrag: true,
        // },
        // handleScale: {
        // 	axisPressedMouseMove: {
        // 		time: true,
        // 		price: true,
        // 	},
        // 	axisDoubleClickReset: {
        // 		time: true,
        // 		price: true,
        // 	},
        // 	mouseWheel: true,
        // 	pinch: true,
        // },
        // kineticScroll: {
        // 	mouse: false,
        // 	touch: true,
        // },
        // trackingMode: {
        // 	exitMode: TrackingModeExitMode.OnNextTap,
        // },
    });

    useEffect(() => {
        const chartContainer = document.getElementById("div-chart-content");
        if (!chartContainer) return;
    
        const resizeObserver = new ResizeObserver(entries => {
            for (let entry of entries) {
                const { width, height } = entry.contentRect;
    
                setChartOptions(prev => ({
                    ...prev,
                    width: width,
                    height: height , 
                }));
    
                if (chartRef.current?.chart) {
                    chartRef.current.chart.resize(width, height);
                }
            }
        });
    
        resizeObserver.observe(chartContainer);
    
        // Clean-up
        return () => {
            resizeObserver.disconnect();
        };
    }, []);

return (
      <Chart {...chartOptions} ref={chartRef}>
            <Series chart={chartRef} />
        </Chart>
    );
}  